module.exports = __webpack_public_path__ + "static/8-4ef28cb0b9e801592ef09bc52a33a7ab.jpg";